import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { Button, Card, Pagination, Row, Spin, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../../redux/actions";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import TableSearchFilter from "../../component/TableSearchFilter";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";

const ManageInterbankContract = (props) => {
  const pageSize = 10; //number of items per page
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [interbankList, setInterbankList] = useState([]);
  const { userData, rightBtn, rightAction } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [tableStatus, setTableStatus] = useState("Active");
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { session } = userData;

  const filteredData =
    tableStatus === "Status"
      ? interbankList
      : interbankList.filter((item) => item.status === tableStatus);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalPages = Math.ceil(filteredData.length / pageSize);

  useEffect(() => {
    BOM.HasPermission("READ_INTERBANKPLACEMENTCONTRACT") &&
      getInterBankContractListAction();
    BOM.HasPermission("CREATE_INTERBANKPLACEMENTCONTRACT") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getInterBankContractListAction = () => {
    let body = {
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      apiConfig.Interbankplacementcontracts,
      (err, res) => {
        if (err) {
          setIsLoading(false);
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          setIsLoading(false);

          const objList = res;
          let tempArray = [];
          objList?.forEach((element) => {
            tempArray.push({
              id: element?.id,
              key: element?.id,
              // counterpartyType: counterpartyTypeNames,
              currency: element?.currency?.code || "-",
              contractRefId: element?.contractReferenceId
                ? element?.contractReferenceId
                : "-",
              status: element?.status?.text || "-",
              accountNo: element?.accountNo ? element?.accountNo : "-",
              customerId: element?.client?.id ? element?.client?.id : "-",
              // status: handleFlgStatus(element?.status?.value, {}, true),
              maturityDate: element?.maturityDate
                ? BOM.DateTime(element?.maturityDate, "only-date")
                : "-",
              date: element?.submittedOnDate
                ? BOM.DateTime(element?.submittedOnDate, "only-date")
                : "-",
              dealValue:
                element?.amount && element?.amount !== 0
                  ? Number(element?.amount).toLocaleString()
                  : "-",

              // otherKeys: {
              //   statusValue: element?.status?.value, // The status value will be used on the detail screen
              //   accountNo: element?.accountNo,
              // },
            });
          });

          //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
          setInterbankList(tempArray);

          //keep the orginal interbankList to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(
        body,
        apiConfig.Interbankplacementcontracts,
        (err, res) => {
          if (err) {
            reject(err);
          } else {
            setIsLoading(false);

            const objList = res;
            let tempArray = [];
            objList?.forEach((element) => {
              tempArray.push({
                id: element?.id,
                key: element?.id,
                // counterpartyType: counterpartyTypeNames,
                currency: element?.currency?.code || "-",
                contractRefId: element?.contractReferenceId
                  ? element?.contractReferenceId
                  : "-",
                status: element?.status?.text || "-",
                accountNo: element?.accountNo ? element?.accountNo : "-",
                customerId: element?.client?.id ? element?.client?.id : "-",
                // status: handleFlgStatus(element?.status?.value, {}, true),
                maturityDate: element?.maturityDate
                  ? BOM.DateTime(element?.maturityDate, "only-date")
                  : "-",
                date: element?.submittedOnDate
                  ? BOM.DateTime(element?.submittedOnDate, "only-date")
                  : "-",
                dealValue:
                  element?.amount && element?.amount !== 0
                    ? Number(element?.amount).toLocaleString()
                    : "-",

                // otherKeys: {
                //   statusValue: element?.status?.value, // The status value will be used on the detail screen
                //   accountNo: element?.accountNo,
                // },
              });
            });

            resolve(tempArray);
          }
        }
      );
    });
  };

  const onSelectItemAction = (objParam, selectedRow) => {
    // If no row or multiple rows selected, reset read and update
    console.log(objParam);
    console.log(selectedRow);

    if (objParam.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      // Re-activate other buttons that should remain (like addBtn)
      BOM.HasPermission("CREATE_INTERBANKPLACEMENTCONTRACT") &&
        dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    setSelectedRow(selectedRow[0]);

    if (BOM.HasPermission("READ_INTERBANKPLACEMENTCONTRACT")) {
      dispatch({ type: cnt.RIGHT_DETAIL_BTN });
    }
    if (
      selectedRow[0]?.status?.toLowerCase() === "pending" &&
      BOM.HasPermission("UPDATE_INTERBANKPLACEMENTCONTRACT ")
    ) {
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
    }
  };

  // const onSelectItemAction = (selectedKeys, selectedRows) => {
  //   //HOLD THE OBJECT SELECTED HERE
  //   setSelectedRowKeys(selectedKeys);
  //   setSelectedRow(selectedRows);

  //   if (selectedKeys.length === 1) {
  //     dispatch({ type: cnt.CLEAR_RIGHT_BTN });
  //     [cnt.RIGHT_DETAIL_BTN].map((item) => {
  //       dispatch({ type: item });
  //     });
  //     // will be changes when endpoint is give
  //     dispatch({ type: cnt.RIGHT_ADD_BTN });
  //     dispatch({ type: cnt.RIGHT_EDIT_BTN });
  //   } else if (selectedKeys.length > 1) {
  //     dispatch({ type: cnt.RIGHT_ADD_BTN });
  //     dispatch({ type: cnt.RIGHT_EDIT_BTN });

  //     // dispatch({ type: cnt.RIGHT_DELETE_BTN });
  //   } else {
  //     dispatch({ type: cnt.CLEAR_RIGHT_BTN });
  //     dispatch({ type: cnt.RIGHT_ADD_BTN });
  //   }
  // };

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/create-interbank-contract", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }

  function handleOnView() {
    console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-interbank-contract", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-interbank-contract", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const columns = [
    {
      title: (
        <div className="flex items-center">
          <span>Contract Ref ID</span>
          <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
        </div>
      ),
      dataIndex: "contractRefId",
      key: "contractRefId",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
    },
    {
      title: "Deal Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
      key: "maturityDate",
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let bgColor = "#F9FAFB"; // default bg
        let textColor = "#344054"; // default text
        let border = "1px solid #EAECF0";

        switch (text) {
          case "Active":
            bgColor = "#ECFDF3";
            textColor = "#067647";
            border = "1px solid #ABEFC6";
            break;
          case "Inactive":
            bgColor = "#FEE4E2";
            textColor = "#B42318";
            break;
          case "Rejected":
          case "Closed":
            bgColor = "#FEF3F2";
            textColor = "#B42318";
            border = "1px solid #FECDCA";
            break;
          case "Approved":
            bgColor = "#EEF4FF";
            textColor = "#3538CD";
            border = "1px solid #C7D7FE";
            break;
          case "WithdrawnByApplicant":
            bgColor = "#F0F9FF";
            textColor = "#026AA2";
            border = "1px solid #B9E6FE";
            break;
          // case "Pending":
          //   bgColor = "#F4F3FF";
          //   textColor = "#5925DC";
          //   border = "1px solid #D9D6FE";
          //   break;
          default:
            break;
        }

        return (
          <Tag
            style={{
              padding: "2px 12px",
              borderRadius: "16px",
              border: border,
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              backgroundColor: bgColor,
              color: textColor,
              textTransform: "capitalize",
            }}
          >
            {text}
          </Tag>
        );
      },
    },
  ];

  const csvColumns = [
    {
      title: "Contract Ref ID",
      dataIndex: "contractRefId",
      key: "contractRefId",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
    },
    {
      title: "Deal Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
      key: "maturityDate",
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  // PAINATION ARROE DISABLING
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const searchFIlter = paginatedData.filter(
    (item) =>
      item.contractRefId.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.customerId === parseInt(searchText)
    // item.customerId?.includes(parseInt(searchText))
  );

  const handleSelectOnChange = (value) => {
    // console.log(value);

    setTableStatus(value);
    setCurrentPage(1); // Reset to page 1 on filter change
  };

  const hanleOnChangeSearchInput = (e) => {
    const text = e.target.value;
    setSearchText(text);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
      pageItems={staticConfig.contractbookingInterbankPlacementBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.manageContractBookingInterbankplacement}
        createPageTitle={labelConfig.contractBookingInterbankplacement}
      />
      <Card
        style={{
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <div className="p-6 bg-white rounded-lg shadow-sm check-ant-design">
            {/* Top Bar */}
            <Row style={{ marginBottom: 20 }}>
              <TableSearchFilter
                searchPlaceholder="Search by Contract Ref. ID/Customer ID"
                selectOptions={staticConfig.statusLabels}
                selectValue={tableStatus}
                onSelectChange={handleSelectOnChange}
                onSearchChange={hanleOnChangeSearchInput}
                searchText={searchText}
              />

              <DownloadTableButtons
                downloadData={interbankList}
                columns={csvColumns}
                fileName="Interbank Contract List"
                // onExportClick={getCsvListData}
              />
            </Row>

            <div className="interbankplacement-table">
              <Table
                rowSelection={{
                  onChange: onSelectItemAction,
                  hideSelectAll: true,
                }}
                columns={columns}
                pagination={false}
                dataSource={searchFIlter}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <div
                className="interbankplacement-table-pagination"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  <ArrowLeftOutlined />
                  Previous
                </Button>

                <Pagination
                  current={currentPage}
                  total={filteredData.length}
                  pageSize={pageSize}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  // hideOnSinglePage={true}  // This hides the pagination when there's only one page
                />

                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage >= totalPages}
                >
                  Next
                  <ArrowRightOutlined />
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageInterbankContract);
